<template>
  <CCol>
    <CRow>
      <CCol sm="12">
        <CRow>
          <CCol v-if="loading" sm="12" class="d-flex justify-content-center align-items-center mb-3" style="height: 300px">
            <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
          </CCol>

          <template v-else>
            <CCol sm="12">
              <CButton @click="gotemplates" tag="button" class="btn bt-white w-100 btn-choose mb-4 text-uppercase font-xs py-3">
                <CIcon name="changeEmail" :height="32" viewBox="0 0 32 32" />
                <br />
                <p class="mb-0 text-uppercase" v-if="templateId">
                  {{ $t('campaign.creator.blockLibrary.email-content.change-email') }}
                </p>
                <p class="mb-0 text-uppercase" v-else>
                  {{ $t('campaign.creator.blockLibrary.email-content.choose-email') }}
                </p>
              </CButton>
            </CCol>

            <!-- 1 = simples text || 2 = html -->
            <imageTemplate
              v-if="this.contentType == 2"
              :template="{ templateName, thumbnailUri, templateId, isUnlayer, indexChannel: indice, contentType }"
              :edit="true"
              :dynamicDestinationType="DYNAMIC_TEMPLATE_DESTINATION_TYPE.CAMPAIGN"
            />

            <textSimple v-else :template="{ templateName, emailSimpleText, templateId, contentType }" :indexChannel="indexChannel" :edit="true" />

            <CCol sm="12" class="mt-3">
              <label style="margin-bottom: 0px" class="typo__label">{{ $t('campaign.creator.blockLibrary.email-content.label-subject') }}</label>
              <div>
                <label style="font-size: 13px" for="CustomFields" class="text-gray-500 text-uppercase">
                  {{ $t('campaign.creator.blockLibrary.email-content.custom-fields') }}
                  <span class="text-gray-500 text-uppercase">({{ $t('campaign.creator.blockLibrary.email-content.options') }})</span>
                </label>
                <CRow :gutters="false" class="d-flex align-items-center mb-2">
                  <CCol sm="12">
                    <multiselect
                      v-model="customField"
                      :multiple="false"
                      :options="customFieldsList"
                      :customLabel="customLabel"
                      custom
                      ref="textAreaCustom"
                      class="multiselect--custom"
                      :allow-empty="false"
                      :show-labels="false"
                      :placeholder="$t(`sidebar.blocksLibrary.campaign.component.content.options.label.select-one`)"
                    >
                    </multiselect>
                  </CCol>

                  <CCol sm="12" class="mt-2 mb-3">
                    <CButton
                      :disabled="customField == null"
                      type="button"
                      class="btn btn-primary text-uppercase font-sm w-100"
                      @click="addCustomField()"
                    >
                      {{ $t('campaign.creator.blockLibrary.email-content.buttom-add') }}</CButton
                    >
                  </CCol>
                </CRow>
              </div>
              <div class="form-group form-group--line">
                <textarea
                  v-model="subject"
                  rows="4"
                  maxlength="100"
                  style="resize: none"
                  ref="textarea"
                  class="text-gray-600 w-100 form-control"
                  @input="saveContent"
                >
                </textarea>
              </div>
            </CCol>

            <CCol sm="12" v-if="templateId">
              <!--<div class="mb-3">
                <label class="typo__label">From*</label>
                <CInput
                  @input="saveContent"
                  v-model.trim="$v.from.$model"
                  placeholder="Reply to"
                  class="form-group--line"
                  maxlength="50"
                  :isValid="checkIfValid('from')"
                  :invalidFeedback="'This is a required field and must be valid e-mail address'"
                />
              </div>-->

              <div class="mb-3">
                <label for="sender" class="text-capitalize">
                  {{ $t('campaign.creator.blockLibrary.email-content.from') }}
                </label>
                <CInput
                  @input="saveContent"
                  v-model="displayName"
                  :placeholder="$t('campaign.creator.blockLibrary.email-content.label.displayName')"
                  class="form-group--line"
                  maxlength="50"
                />
                <label for="sender" class="">{{ $t('campaign.creator.blockLibrary.email-content.sender') }}</label>

                <CInput
                  @input="saveContent"
                  v-model="emailPrefix"
                  @keypress="isAlphaNum($event)"
                  @paste="isAlphaNum($event)"
                  :placeholder="$t('campaign.creator.blockLibrary.email-content.email-prefix')"
                  class="form-group--line"
                  maxlength="50"
                />
                <multiselect
                  v-model="senderDomain"
                  :loading="isLoadingSendersDomain"
                  :multiple="false"
                  :options="senderDomainList"
                  custom
                  :custom-label="(option) => option.label"
                  :allow-empty="false"
                  :show-labels="false"
                  class="multiselect--custom"
                  :placeholder="$t('campaign.creator.blockLibrary.email-content.selectDomain')"
                  @input="saveContent"
                >
                  <template slot="singleLabel" slot-scope="props">
                    {{ senderDomain ? senderDomain.label : $t(`sidebar.blocksLibrary.campaign.component.content.options.label.select-one`) }}
                  </template>
                  <template slot="option" slot-scope="props">
                    <CRow>
                      <CCol>{{ props.option.label }} </CCol>
                      <CCol class="text-right" v-if="props.option.route">
                        <CButton class="px-3 py-1" color="primary">
                          {{ $t(`sidebar.blocksLibrary.campaign.component.content.options.button.new`) }}
                        </CButton>
                      </CCol>
                    </CRow>
                  </template>
                </multiselect>
              </div>

              <div class="mt-3">
                <label class="typo__label text-gray-500 text-uppercase" style="font-size: 13px">
                  {{ $t('campaign.creator.blockLibrary.email-content.reply') }}</label
                >
                <CInput
                  @input="saveContent"
                  v-model.trim="$v.replyTo.$model"
                  :placeholder="$t('campaign.creator.blockLibrary.email-content.reply')"
                  maxlength="50"
                  class="form-group--line"
                  :isValid="checkIfValid('replyTo')"
                  :invalidFeedback="$t('campaign.creator.blockLibrary.email-content.replay')"
                />
              </div>
            </CCol>
          </template>
        </CRow>
      </CCol>
    </CRow>
  </CCol>
</template>

<script>
import services from '@/services.js'
import imageTemplate from '../imageTemplate'
import TextSimple from '../TextSimple'
import { validationMixin } from 'vuelidate'
import { email } from 'vuelidate/lib/validators'
import { DYNAMIC_TEMPLATE_DESTINATION_TYPE } from '@/views/template/constants.js'

const CUSTOM_GROUP = 'CUSTOM'

export default {
  name: 'EmailContent',
  components: {
    imageTemplate,
    TextSimple,
  },
  props: {
    content: {
      type: Object,
    },

    indice: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isUnlayer: false,
      loading: false,
      currentAlertCounter: 0,
      from: '',
      displayName: '',
      replyTo: '',
      templateName: '',
      emailSimpleText: '',
      contentType: null,
      subject: '',
      templateId: '',
      thumbnailUri: '',
      htmlFileUri: '',
      customField: null,
      emailMessage: null,
      customFieldsList: [],
      senderDomainList: [],
      senderDomain: {},
      emailPrefix: '',
      isLoadingSendersDomain: false,
      DYNAMIC_TEMPLATE_DESTINATION_TYPE: DYNAMIC_TEMPLATE_DESTINATION_TYPE,
    }
  },
  mixins: [validationMixin],
  validations: {
    from: {},
    replyTo: {
      email,
    },
  },

  mounted() {
    this.resetValues()
    this.getSchema()
    this.getSendersDomain()
  },

  methods: {
    isAlphaNum(event) {
      var regex = new RegExp('^[a-zA-Z0-9._+,\\-]+$')
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode)
      if (!regex.test(key)) {
        event.preventDefault()
        return false
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },

    getSendersDomain() {
      let organizationId = this.$route.params.organizationId

      this.isLoadingSendersDomain = true

      services
        .getSendersDomainByOrganizationUserId(organizationId)
        .then((res) => {
          let list = res.data.data.map((elm) => {
            return { value: elm.senderId, label: '@' + elm.sender }
          })

          if (list?.length > 0) {
            this.senderDomainList = list
          } else {
            this.senderDomain = null
            this.senderDomainList = [
              {
                label: this.$t(`sidebar.blocksLibrary.campaign.component.content.options.label.emptyList`),
                value: 'new',
                route: { name: 'new-senders-domain' },
              },
            ]
          }
          this.$store.commit('campaign/UPDATE_AUXILIARES', {
            sendersDomains: [...this.senderDomainList],
          })
        })
        .finally(() => {
          this.isLoadingSendersDomain = false
        })
    },

    async gotemplates() {
      this.loading = true

      let organizationId = this.$store.state.auth.organizationId
      let obj = {
        organizationId: organizationId,
        campaignId: this.$route.params.campaignId,
      }

      this.$store
        .dispatch('campaign/savePathCampaign', obj)
        .then(() => {
          this.$router.push({
            name: 'new-template-list',
            params: {
              dynamicId: this.$route.params.campaignId,
              dynamicIndex: this.indice,
              dynamicDestinationType: DYNAMIC_TEMPLATE_DESTINATION_TYPE.CAMPAIGN,
            },
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    saveContent() {
      if (this.senderDomain.route != null) {
        this.$router.push({ name: this.senderDomain.route.name })
        return
      }

      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      } else {
        let model = {
          indice: this.indice,
          content: {
            from: this.emailPrefix + this.senderDomain.label,
            displayName: this.displayName,
            templateId: this.templateId,
            contentType: parseInt(this.contentType),
            subject: this.subject,
            replyTo: this.replyTo,
            thumbnailUri: this.thumbnailUri,
            htmlFileUri: this.htmlFileUri,
            templateName: this.templateName,
            emailSimpleText: this.emailSimpleText,
            senderId: this.senderDomain.value,
            senderName: this.senderDomain.label,
            emailPrefix: this.emailPrefix,
          },
        }
        this.$store.dispatch('campaign/setEmailContent', JSON.parse(JSON.stringify(model)))
      }
    },

    customLabel(option) {
      return `${option.value}`
    },

    async getSchema() {
      try {
        const FIELD_TYPES = await services.fieldtypes(this.$store.state.auth.organizationId)

        const SCHEME = await services.audienceSchema(this.$store.state.auth.organizationId)

        if (SCHEME.data.data.errorCode === 1000) {
          this.customFieldsList = [...this.handleCustomtypes(FIELD_TYPES)]
          throw 'AUDIENCE_SCHEMA_NOT_FOUND'
        }

        this.customFieldsList = [...SCHEME.data.data.values, ...this.handleCustomtypes(FIELD_TYPES)]
      } catch (error) {
        // Implementar casos de erro
      }
    },

    handleCustomtypes(FIELD_TYPES) {
      let CUSTOMS = FIELD_TYPES.data.data.groups.filter((group) => group.group == CUSTOM_GROUP)

      if (CUSTOMS[0].types.lenght) {
        return CUSTOMS.map((item, index) => {
          return {
            ...item.types[index],
            value: item.types[index].personalizationTag,
          }
        })
      }

      return []
    },

    addCustomField() {
      this.$refs.textarea.focus()
      if (this.customField === null || this.customField == '') {
        return
      }

      // this.hasCustomField = true
      document.execCommand('insertText', false, '[' + this.customField.personalizationTag + '] ')
    },

    checkProperties(obj) {
      for (var key in obj) {
        if (obj[key] !== null && obj[key] != '') return false
      }
      return true
    },

    templateEmail() {
      this.$root.$emit('preview-email', {
        status: true,
        templateId: this.template.templateId,
      })
    },

    resetValues() {
      this.customField = null

      const CONTENT = JSON.parse(JSON.stringify(this.content))

      this.from = CONTENT.from || ''
      this.displayName = CONTENT.displayName || ''
      this.templateId = CONTENT.templateId || ''
      this.contentType = parseInt(CONTENT.contentType) || ''
      this.subject = CONTENT.subject || ''
      this.replyTo = CONTENT.replyTo || ''
      this.thumbnailUri = CONTENT.thumbnailUri || ''
      this.templateName = CONTENT.templateName || ''
      this.htmlFileUri = CONTENT.htmlFileUri || ''
      this.emailSimpleText = CONTENT.emailSimpleText || ''
      this.senderDomain.value = CONTENT.senderId || ''
      this.senderDomain.label = CONTENT.senderName || ''
      this.emailPrefix = CONTENT.emailPrefix || ''
    },

    async getTemplate() {
      this.messages = []
      this.loading = true
      try {
        let organizationId = this.$store.state.auth.organizationId
        const TEMPLATE_PAYLOAD = await services.getTemplate(organizationId, this.templateId)
        this.thumbnailUri = TEMPLATE_PAYLOAD.data.data.thumbnailUri
        this.htmlFileUri = TEMPLATE_PAYLOAD.data.data.htmlFileUri
        this.isUnlayer = Boolean(TEMPLATE_PAYLOAD.data.data.htmlBuilderData)
      } catch (error) {
        this.messages.push({
          status: 'danger',
          text: error.response.data.message || 'Error',
        })
      } finally {
        this.loading = false
      }
    },
  },

  computed: {
    campaignId() {
      return this.$route.params.campaignId
    },

    mainCampaign() {
      return this.$store.state.campaign.mainCampaign
    },

    indexChannel() {
      return this.indice
    },

    hasEmailEmailSimpleText() {
      return this.emailSimpleText
    },
  },

  watch: {
    indice: {
      handler() {
        this.resetValues()
        this.getSendersDomain()
      },
    },

    thumbnailUri() {
      this.saveContent()
    },

    templateId: {
      handler() {
        this.getTemplate()
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-choose {
  border: 1px solid var(--gray-500) !important;

  &:hover {
    border: 1px solid var(--primary) !important;
    color: var(--black) !important;

    .c-icon {
      color: var(--primary) !important;
    }
  }
}
</style>
